<template>
  <div class="confirm-info" :style="{height: viewportHeight}">
    <HomeHeader scroll-top="300"></HomeHeader>
    <div class="flex-column container w-wrapper">
      <div class="flex-column main">
        <div class="title">企业MCN机构申请</div>
        <div class="steps-box">
          <el-steps :active="3" align-center>
            <el-step title="选择公会类型"></el-step>
            <el-step title="填写公会信息"></el-step>
            <el-step title="填写资质信息"></el-step>
            <el-step title="确认信息"></el-step>
            <el-step title="等待审核"></el-step>
            <el-step title="完成入驻"></el-step>
          </el-steps>
        </div>
        <div class="form-box">
          <div class="right-info">
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">企业类型</div>
              <div class="right-info-item-value">
                <span v-if="applyDetail.mcnType === 1">企业</span>
                <span v-else-if="applyDetail.mcnType === 2">个人</span>
                <span v-else>未知</span>
              </div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">负责人姓名</div>
              <div class="right-info-item-value">{{ applyDetail.contactName }}</div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">负责人身份</div>
              <div class="right-info-item-value">
                <span v-if="applyDetail.contactRole === 1">无</span>
                <span v-else-if="applyDetail.contactRole === 2">区县代理人</span>
                <span v-else-if="applyDetail.contactRole === 3">市级代理人</span>
                <span v-else-if="applyDetail.contactRole === 4">省级代理人</span>
              </div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">手机号码</div>
              <div class="right-info-item-value">{{ applyDetail.contactPhone }}</div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">身份证照片</div>
              <div class="right-info-item-value">
                <el-image
                    class="id-card-img"
                    fit="contain"
                    :src="applyDetail.contactIdCardFrontUrl"
                    :preview-src-list="[applyDetail.contactIdCardFrontUrl, applyDetail.contactIdCardBackUrl]">
                </el-image>
                <el-image
                    class="id-card-img"
                    fit="contain"
                    :src="applyDetail.contactIdCardBackUrl"
                    :preview-src-list="[applyDetail.contactIdCardBackUrl]">
                </el-image>
              </div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">身份证号码</div>
              <div class="right-info-item-value">{{ applyDetail.contactIdCard }}</div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">公会名称</div>
              <div class="right-info-item-value">{{ applyDetail.orgName }}</div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">公会介绍</div>
              <div class="right-info-item-value">{{ applyDetail.orgDescription }}</div>
            </div>
            <div v-if="applyDetail.mcnType === 1" class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">公司营业执照</div>
              <div class="right-info-item-value">
                <el-image
                    class="id-card-img"
                    :src="applyDetail.businessLicenseUrl"
                    :preview-src-list="[applyDetail.businessLicenseUrl]">
                </el-image>
              </div>
            </div>
            <div v-if="applyDetail.mcnType === 1" class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">企业名称</div>
              <div class="right-info-item-value">{{ applyDetail.businessLicenseName }}</div>
            </div>
            <div v-if="applyDetail.mcnType === 1" class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">营业性演出许可证</div>
              <div class="right-info-item-value">
                <el-image
                    v-for="item in applyDetail.otherLicenseList"
                    :key="item"
                    fit="cover"
                    class="id-card-img"
                    :src="item"
                    :preview-src-list="applyDetail.otherLicenseList">
                </el-image>
              </div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">签约主播数量</div>
              <div class="right-info-item-value">{{ applyDetail.anchorAmount }}</div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">签约主播证明材料</div>
              <div class="right-info-item-value">
                <el-image
                    v-for="item in applyDetail.anchorEvidentiaryList"
                    :key="item"
                    fit="cover"
                    class="id-card-img"
                    :src="item"
                    :preview-src-list="applyDetail.anchorEvidentiaryList">
                </el-image>
              </div>
            </div>
            <div class="flex-row right-info-item-col">
              <div class="flex-center-row right-info-item-label">签约主播来源</div>
              <div class="right-info-item-value">{{ applyDetail.anchorSource }}</div>
            </div>
          </div>
          <div class="footer-btn">
            <div v-if="applyDetail.status === 4">
              <div class="delete-reason">您的账号已注销，注销原因：{{ applyDetail.reason }}</div>
              <el-button
                  style="width: 500px"
                  type="primary"
                  @click="submitForm()">重新申请
              </el-button>
            </div>
            <div v-else>
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-button
                      style="width: 100%"
                      type="default"
                      @click="goStepTwo()">上一步
                  </el-button>
                </el-col>
                <el-col :span="8">
                  <el-button
                      style="width: 100%"
                      type="primary"
                      @click="submitForm()">确认无误，提交入驻审核
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import {getSMSVerifyCode} from "@/apis/login";
import {encryptECB} from "@/utils/parsing";
import {getImgVerifyCode, joinApplyProgress, submitSaveAll} from "@/apis/audit";
import {getItem} from "@/utils/storage";

export default {
  name: "select-type",
  components: {
    HomeHeader
  },
  data() {
    return {
      viewportHeight: '100vh',
      applyDetail: {}, // 申请详情
      imgCodeUrl: '', // 图形验证码
      imgKey: '', // 图形验证码的key
      ruleForm: {
        contactName: '亚朋', //	负责人姓名	true string
        contactRole: '2', //	负责人身份 1-无 2-区县代理人 3-市级代理人 4-省级代理人		true integer(int32)
        contactPhone: '18513558880',	// 负责人手机号码, aes加密		true string
        smsCode: '', //	短信验证码		true string
        smsKey: '', //	获取验证码时的Key
        contactIdCardFrontUrl: '', 	// 负责人身份证-正面		true string
        contactIdCardBackUrl: '',	// 负责人身份证-背面		true string
        contactIdCard: '312716199809071212',	// 负责人身份证号码		true string
        orgName: '亚朋公会', //	机构名称		true string
        orgDescription: '亚朋公会', // 	机构介绍		true string
        mcnType: '1', //	公会类型 1-企业 2-个人		true integer(int32)
      },
      rules: {
        contactName: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        contactRole: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        contactPhone: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        smsCode: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        contactIdCard: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        orgName: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        orgDescription: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    if (this.$route.query.mcnType) {
      this.ruleForm.mcnType = this.$route.query.mcnType
    }
    this.getImgVerifyCodeApi()
    this.joinApplyProgressApi()
  },
  methods: {
    joinApplyProgressApi() {
      const applyId = getItem('applyId')
      if (!applyId) {
        return
      }
      this.applyId = applyId
      joinApplyProgress({applyId: this.applyId}).then(res => {
        const data = res.data || {}
        this.applyDetail = data
        const status = data.status || -1 // 状态 0-草稿 1-待审核 2-审核通过 3-审核失败 4-已退出
        this.applyStatus = status
        if (status === 2) {
          this.$router.push({
            path: '/apply/finish-enter',
            query: {
              status: status
            }
          })
        }
      })
    },
    // 获取图文验证码
    getImgVerifyCodeApi() {
      getImgVerifyCode({
        phone: encryptECB(this.ruleForm.contactPhone)
      }).then(res => {
        this.imgCodeUrl = res.data.code
        this.imgKey = res.data.key
      })
    },
    // 获取短信验证码
    getSMSVerifyCodeApi() {
      if (!this.ruleForm.code) {
        return this.$message({
          message: '请输入图文验证码',
          type: 'warning'
        })
      }
      getSMSVerifyCode({
        code: this.ruleForm.code,
        key: this.imgKey,
        phone: encryptECB(this.ruleForm.contactPhone)
      }).then((res) => {
        this.ruleForm.smsKey = res.data.key
        this.$message({
          message: '验证码已发送，请注意查收',
          type: 'success'
        });
      })
    },
    // 提交表单
    submitForm() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      submitSaveAll({
        version: this.applyDetail.version || 0, // 版本号
        applyId: this.applyId
      }).then(res => {
        if (res.data && typeof res.data === "boolean" && res.data === false) {
          this.$message.warning('数据已更新，正在为您刷新页面')
          return setTimeout(() => {
            this.$router.go(0)
          }, 2000)
        }
        console.log(res)
        this.$message.success('提交成功，请耐心等待审核结果')
        this.$router.push({
          path: '/apply/wait-audit?status=1'
        })
      }).catch((err) => {
        if (err.data && typeof err.data === "boolean" && err.data === false) {
          setTimeout(() => {
            this.$router.go(0)
          }, 2000)
        }
      }).finally(() => {
        loading.close()
      })
    },
    goStepTwo() {
      this.$router.replace({
        path: '/apply/step-two'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-info {
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}

.container {
  margin: 60px auto 0;
  height: calc(100% - 100px);

  .back {
    padding: 16px 16px 16px 0;
    width: max-content;
    font-size: 16px;
    cursor: pointer;
  }

  .main {
    overflow-y: hidden;
    flex: 1;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 20px 0;
    border-radius: 4px;
    background-color: #ffffff;

    .steps-box {
      width: 800px;
      margin: 0 auto;
    }

    .form-box {
      flex: 1;
      overflow-y: auto;
      margin: 20px 0 0;
      padding: 30px 240px 20px;

      .right-info {
        border-left: 1px solid #E4E7ED;
        border-top: 1px solid #E4E7ED;

        .right-info-item-col {
          border-right: 1px solid #E4E7ED;
          border-bottom: 1px solid #E4E7ED;

          .right-info-item-label {
            width: 120px;
            text-align: center;
            background-color: #efefef;
            color: #515a6e;
            font-size: 12px;
          }

          .right-info-item-value {
            flex: 1;
            overflow: hidden;
            word-break: break-all;
            margin-left: 6px;
            padding: 12px 0;

            .id-card-img {
              width: 100px;
              height: 100px;
              margin-right: 10px;
              cursor: pointer;
            }
          }
        }
      }

      .footer-btn {
        margin-top: 64px;
        padding-left: 120px;

        .delete-reason {
          text-align: center;
          color: #f56c6c;
        }
      }
    }

    .title {
      margin-bottom: 30px;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }

    .type-item {
      margin: 20px 0;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }
    }
  }
}
</style>